// extracted by mini-css-extract-plugin
module.exports = {"icon--primary":"dynamo-icon_icon--primary__dtULc","icon--secondary":"dynamo-icon_icon--secondary__8hnAH"};